import React from 'react';
import { TFunction, useTranslation } from '@wix/yoshi-flow-editor';
import { TagName } from '../../../../utils/tagName.const';
import { DateAndTimeDataHooks } from './dataHooks';
import { DateTimeFormatter } from '@wix/bookings-date-time';
import Text, { TextType } from '../../Text/Text';
import { useEditorContext } from '../../Hooks/useEditorContext';
import { classes } from './DateAndTime.st.css';

export interface DateAndTimeProps {
  dateRegionalSettingsLocale: string;
  startDate: string;
  totalNumberOfSessions: number;
}
const DateAndTime: React.FC<DateAndTimeProps> = ({
  totalNumberOfSessions,
  startDate,
  dateRegionalSettingsLocale,
}) => {
  const { t } = useTranslation();
  const editorContext = useEditorContext();

  const dateAndTime = editorContext.isDummy
    ? t('app.dummy-data.date-and-time')
    : getDateAndTime(
        startDate,
        dateRegionalSettingsLocale,
        totalNumberOfSessions,
        t,
      );

  return (
    <Text
      className={classes.root}
      type={TextType.Primary}
      data-hook={DateAndTimeDataHooks.SLOT_DATE_AND_TIME}
      tagName={TagName.Paragraph}
    >
      {dateAndTime}
    </Text>
  );
};

const getDateAndTime = (
  startDate: string,
  dateRegionalSettingsLocale: string,
  totalNumberOfSessions: number,
  t: TFunction,
) => {
  const dateAndTimeFormatter = new DateTimeFormatter(
    dateRegionalSettingsLocale!,
  );
  const dateAndTimeFormat = dateAndTimeFormatter.formatDateAndTime(startDate);
  const isServiceHasMultipleSessions = totalNumberOfSessions > 1;

  return isServiceHasMultipleSessions
    ? t('app.booking-details.course.date-and-time.starts.text', {
        date: dateAndTimeFormat,
      })
    : dateAndTimeFormat;
};

export default DateAndTime;
